import React from "react";
import SalePromotionsForm from "../../../components/forms/promotions/SalePromotionsForm";
import BackButton from "../../../components/common/BackButton";

const SalePromotionsPage = () => {
  return (
    <div className="px-16 py-8 text-gray-900">
      <BackButton></BackButton>
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b">Carrusel</p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <SalePromotionsForm />
        </div>
      </div>
    </div>
  );
};

export default SalePromotionsPage;
